import Swiper, { Navigation } from "swiper";
import "swiper/css";
Swiper.use([Navigation]);

export default class Slider {
  constructor() {
    this.init();
  }

  init() {
    const swiper = new Swiper(".p-index__slider", {
      modules: [Navigation],
      autoplay: true,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 16,
      centeredSlides: true,
      navigation: {
        nextEl: ".p-index__slider__navigation__next",
        prevEl: ".p-index__slider__navigation__prev",
        disabledClass: "swiper-button-disabled",
      },
      breakpoints: {
        768: {
          slidesPerView: 1.5,
        },
      },
    });
  }
}
